import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CustomMaterialSchema } from '../schema';
import { db } from '../instant';

interface Props {
    eventName: string;
    customMaterial?: CustomMaterialSchema;
    numMeasurements: number | undefined;
    open: boolean;
    onClose: () => void;
    removeField: () => void;
}

export default function DeleteCustomMaterialDialog(props: Props) {
    const { user } = db.useAuth();

    if (props.customMaterial?.id === undefined) {
        return <></>;
    }

    const deleteAndClose = async () => {
        if (props.customMaterial) {
            if (props.customMaterial.id) {
                await db.transact(db.tx.wasteMaterials[props.customMaterial.id].delete());
            }

            props.removeField();
            props.onClose();
        }
    };

    const eventName = props.eventName || '<UNDEFINED>';
    const materialName = props.customMaterial.name;

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this custom material?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The material &quot;{materialName}&quot; of event &quot;{eventName}&quot; (and {props.numMeasurements} measurements) will
                    be deleted. This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button disabled={!user} onClick={deleteAndClose} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
